document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rc-section').forEach(function (section) {
    var track = section.querySelector('.rc-track');
    var prev = section.querySelector('.rc-nav--prev');
    var next = section.querySelector('.rc-nav--next');
    if (!track || !prev || !next) return;

    function cardWidth() {
      var card = track.querySelector('.rc-card');
      if (!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 24);
      return card.getBoundingClientRect().width + gap;
    }

    function updateNavState() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateNavState);
    window.addEventListener('resize', updateNavState);
    updateNavState();
  });
});